import { rgba } from 'polished';

import { DefaultEnvImages } from 'enums/env';
import { getEnvVariable } from 'utils/common';

const TOOLTIP_SHADOW_RED = 53;
const TOOLTIP_SHADOW_GREEN = 58;
const TOOLTIP_SHADOW_BLUE = 63;
const TOOLTIP_SHADOW_OPACITY = 0.24;

// delete -Restyled blocks (merge to common blocks) after redesign is finished
const mainTheme = {
  colors: {
    common: {
      logoUrl: `${getEnvVariable(
        'defaultContentDirectoryUrl',
        process.env.DEFAULT_CONTENT_DIRECTORY_URL,
      )}${DefaultEnvImages.Logo}`,
      favicon: `${getEnvVariable(
        'defaultContentDirectoryUrl',
        process.env.DEFAULT_CONTENT_DIRECTORY_URL,
      )}${DefaultEnvImages.Favicon}`,
      layout: {
        scrollLayoutBackgroundColor: '#ffffff',
      },
      accordion: {
        borderColor: 'transparent',
        boxShadowColor: '#e2e2f8',
        expandedBorderTopColor: '#dadae8',
        accordionGroupBorderBottomColor: '#8d9aa6',
        textColor: '#131734',
        iconColor: '#8d9aa6',
        iconHoverColor: '#748493',
      },
      card: {
        boxShadowColor: '#e2e2f8',
        backgroundColor: '#ffffff',
      },
      phoneBlock: {
        textColor: '#131734',
      },
      separatingLine: {
        borderColor: '#dadae8',
      },
      applicationStep: {
        backgroundTabletColor: '#ffffff',
        titleColor: '#292f57',
        overlayBackgroundColor: '#ffffff',
      },
      applicationStepRestyled: {
        overlayBackgroundColor: '#ffffff',
        borderColor: '#e7e7e7',
      },
      chat: {
        chatTitleColor: '#ffffff',
        backgroundColor: '#ffffff',
        footerBorderColor: '#F4F3F3',
        chatDataLoaderColor: '#ffffff',
        swipeLineColor: '#ffffff',
        unreadMessagesCircleColor: '#21d329',
        unreadMessagesTextColor: '#ffffff',
      },
      infoBlock: {
        textColor: '#353a3f',
      },
      warmAccentColor: '',
      coolAccentColor: '',
      pageTitle: '',
    },
    progress: {
      progressWidget: {
        textColor: '#ffffff',
        circleProgressBar: {
          backgroundColor: '#F4F3F3',
          percentageTextColor: '#ffffff',
        },
      },
      flatProgressBar: {
        textColor: '#ffffff',
      },
      applicationStatus: {
        backgroundColorProcessingStarted: '#E9E9E9',
        headingTextColor: '#292f57',
        statusColor: '#757782',
      },
      stateIndicator: {
        textColor: '#ffffff',
        outlinedBorderColor: '#dadae8',
        outlinedBackgroundColor: '#ffffff',
        inactiveStatusBackgroundColor: '#dadae8',
        activeStatusBackgroundColor: '#dadae8',
        inactiveCheckMarkBackgroundColor: '#dadae8',
        outlinedInactiveCheckMarkBorderColor: '#dadae8',
        outlinedInactiveCheckMarkBackgroundColor: '#ffffff',
        outlinedInactiveCheckMarkTextColor: '#dadae8',
      },
    },
    formControls: {
      containedButton: {
        textColor: '#ffffff',
      },
      outlinedButton: {
        backgroundColor: '#ffffff',
        disabledBorderColor: '#8d9aa6',
        disabledTextColor: '#8d9aa6',
        disabledBackgroundColor: '#ffffff',
      },
      underlineButton: {
        textColor: '#757782',
      },
      textField: {
        borderDefaultColor: '#dadae8',
        placeholderColor: '#adb0bd',
        textColor: '#353a3f',
        backgroundColor: '#f4f3f3',
        boxShadowErrorColor: '#fbedf1',
        disabledBorderColor: '#f6f6fa',
        disabledBackgroundColor: '#aeb0b2',
        disabledTextColor: '#353a3f',
        leftIconColor: '#b3b3cf',
        leftIconFocusColor: '#353a3f',
        leftIconHoverColor: '#b3b3cf',
      },
      select: {
        textColor: '#353a3f',
        backgroundColor: '#f4f3f3',
        disabledTextColor: '#353a3f',
        hoverTextColor: '#64666f',
        placeholderColor: '#727579',
        boxShadowErrorColor: '#fbedf1',
        borderDisabledColor: '#f6f6fa',
        backgroundDisabledColor: '#aeb0b2',
        dropDownBoxShadowColor: '#bab9f0',
        dropDownBackgroundColor: '#ffffff',
        dropDownSeparateLineColor: '#dadae8',
        dropDownOptionColor: '#757782',
      },
      checkbox: {
        indicatorColor: '#ffffff',
        uncheckedBorderColor: '#dadae8',
        labelColor: '#353A3F',
      },
      datePicker: {
        boxShadowColor: '#d6d6f6',
        yearBackgroundColor: '#ffffff',
        dayTextColor: '#8d9aa6',
        keyboardSelectedDayBorderColor: '#a1acb6',
        disabledBackgroundColor: '#c1c8ce',
        disabledTextHoverColor: '#8d9aa6',
        iconBorderColor: '#dadae8',
        iconColor: '#dadae8',
        pickerBoxShadowErrorColor: '#fbedf1',
      },
      radioButton: {
        indicatorColor: '#ffffff',
        indicatorBorderHoverColor: '#b3b3cf',
        indicatorBorderUncheckedColor: '#dadae8',
        indicatorBorderDisabledColor: '#dadae8',
        labelBackgroundCheckedColor: '#ececec',
        labelColor: '#353a3f',
      },
      radioCard: {
        backgroundColor: '#ffffff',
        boxShadowColor: '#f0f0fb',
        textColor: '#ffffff',
        borderEnabledHoverColor: '#b3b3cf',
        backgroundCheckedColor: '#f8fcff',
        labelColor: '#8a99a7',
        labelCheckedColor: '#292f57',
      },
    },
    modalViews: {
      backgroundColor: '#ffffff',
      boxShadowColor: '#e2e2f8',
      closeButtonColor: '#757782',
      closeButtonHoverColor: '#64666f',

      assignApplicationModal: {
        titleColor: '#292f57',
      },
      preApprovalLetterModal: {
        headingTitleColor: '#292f57',
        paragraphTitleColor: '#292f57',
      },
      updateLoanInfoModals: {
        titleColor: '#292f57',
      },
      signInModal: {
        titleColor: '#292f57',
        helpTextColor: '#757782',
      },
      ssnVerificationModal: {
        titleColor: '#292f57',
        inputTextColor: '#757782',
      },
    },
    icons: {
      secondaryColor: '',
      commonSettings: {
        backgroundFillCheckedColor: '',
      },
      iconButton: {
        textColor: '',
      },
    },
    iconsRestyled: {
      primaryDefaultFillColor: '#737678',
      defaultBackgroundFillColor: '#edf1fa',
    },
    typography: {
      textBlock: {
        guidelineTextColor: '#292f57',
      },
      label: {
        labelTextColor: '#353A3F',
        outlinedLabelTextColor: '#727579',
      },
      tooltip: {
        boxShadowColor: '#e2e2f8',
        textColor: '#757782',
      },
      strokeText: {
        textColor: '#ffffff',
        strokeColor: '#292f57',
        upperPartTextColor: '#292f57',
        upperPartActiveTextColor: '#ffffff',
        upperPartActiveStrokeTextColor: '#292f57',
      },
      message: {
        borderLeftColor: {
          info: '#1a96fe',
          success: '#00ae7f',
          error: '#ef4141',
          warning: '#FFB800',
        },
        borderShadowColor: '#e2e2f8',
        textColor: '#292f57',
      },
      recommendedMark: {
        textColor: '#ffffff',
      },
    },
    typographyRestyled: {
      tooltip: {
        boxShadowColor: rgba(
          TOOLTIP_SHADOW_RED,
          TOOLTIP_SHADOW_GREEN,
          TOOLTIP_SHADOW_BLUE,
          TOOLTIP_SHADOW_OPACITY,
        ),
        textColor: '#353A3F',
      },
      label: {
        labelTextColor: '#737678',
      },
    },
    footer: {
      footerLinks: [],
      footerLogoUrl: `${getEnvVariable(
        'defaultContentDirectoryUrl',
        process.env.DEFAULT_CONTENT_DIRECTORY_URL,
      )}${DefaultEnvImages.FooterLogo}`,
      enabled: false,
    },
    header: {
      enabled: true,
      backgroundColor: '#ffffff',
      boxShadowColor: '#f0f0fb',
      arrowIconColor: '#adb0bd',
      stickyHeader: {
        backgroundColor: '#ffffff',
      },
    },
    headerRestyled: {
      arrowIconColor: '#737678',
      borderBottomColor: '#E7E7E7',
      profileIconBackground: '#edf1fa',
    },
    widgets: {
      sideBar: {
        boxBackgroundColor: '#ffffff',
        desktopBorderColor: '#dadae8',
        indicatorTextColor: '#ffffff',
        indicatorActiveTextColor: '#ffffff',
        indicatorInactiveTextColor: '#353A3F',
        indicatorInactiveBackgroundColor: '#F4F3F3',
        labelBorderColor: '#ffffff',
        labelTextColor: '#353a3f',
        labelActiveBackgroundColor: '#F4F3F3',
        stepActiveTextColor: '#ffffff',
        subStepLabelColor: '#353a3f',
      },
      tab: {
        hoverTextColor: '#64666f',
        primaryTextColor: '#757782',
        primaryActiveTextColor: '#131734',
        borrowerBorderColor: '#dadae8',
        borrowerTextColor: '#757782',
        borrowerCompletedTextColor: '#00ae7f',
        borrowerCompletedBorderColor: '#00ae7f',
      },
    },
    signing: {
      loader: {
        backgroundColor: '#f3f3f3',
        foregroundColor: '#ecebeb',
      },
    },
    primary: {
      main: '#108FEB', // merges with Main Color from POS Settings in LOS
      accent: '#044BCF', // merges with Hover Main Color from POS Settings in LOS
      dark: '#131734',
      error: '#ef4141',
      text: '#757782',
      textDark: '#292f57',
      menuShadow: '#1d1c84',
      light: '#fff',
      bodyBackground: '#fff',
    },
    primaryRestyled: {
      text: '#353a3f',
      accentText: '#737678',
      textInverted: '#fff',
      bodyBackgroundColor: '#f3f5f9',
      defaultBorderColor: '#e7e7e7',
    },
    secondary: {
      main: '#8d9aa6',
    },
    controls: {
      label: '#adb0bd',
      main: '#dadae8',
      mainSuccess: '#00ae7f',
    },
    status: {
      error: '#ffe7ee',
      info: '#E9E9E9',
      success: '#daf5ee',
    },
    inviteStatus: {
      pending: {
        background: '#FBF1DE',
        text: '#7A5316',
      },
      expired: {
        background: '#FBEFEE',
        text: '#8C1D18',
      },
      accepted: {
        background: '#E4F1E8',
        text: '#22613A',
      },
      cancelled: {
        background: '#ECECEF',
        text: '#4A4F5C',
      },
    },
    // primary.text and primary.error both fall below 4.5:1 on white, which these action labels need.
    inviteActions: {
      neutral: {
        text: '#5F6470',
        border: '#D5D2CC',
      },
      destructive: {
        text: '#B3261E',
        border: '#E3B7B3',
        background: '#FBEFEE',
        title: '#8C1D18',
        body: '#5A2A27',
      },
    },
    card: {
      secondaryText: '#8a99a7',
      mainBg: '#f8fcff',
    },
    skeleton: {
      background: '#f3f3f3',
      foreground: '#ecebeb',
    },
    toast: {
      info: '#1a96fe',
      success: '#00ae7f',
      error: '#ef4141',
      warning: '#FFB800',
    },
  },
  coefficients: {
    paleAccentTransp: 0.96,
    primaryHovered: 0.1,
    primaryFocusedTransp: 0.95,
    primaryDisabled: 0.2,
    primaryTextHovered: 0.14,
    primaryErrorHovered: 0.15,
    secondaryHovered: 0.14,
    secondaryDisabled: 0.18,
    controlsHovered: 0.13,
    controlsDisabled: 0.09,
  },
  breakpoints: {
    mobile: '360px',
    mobileLandscape: '501px',
    tablet: '766px', // in iPad safari screen width can be 766-768px
    desktop: '1280px', // targeting devices that are larger than the iPad (which is 1024px in landscape mode)
  },
  transitions: {
    normal: '0.2s',
  },
} as const;

export default mainTheme;
